import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { useState } from 'react';
import TreeView from 'react-accessible-treeview';
import { Form } from 'react-bootstrap';

const Index = ({
  nodes,
  treeNodeHandler,
  parentNodesCount,
  selectedAllNodes,
  setSelectedAllNodes,
  setSelectedNodes,
  treeIndex
}) => {
  const [selectedParentNodes, setSelectedParentNodes] = useState([]);

  const [isExpand, setIsExpand] = useState(false);

  const handleParentClick = (children, event, index) => {
    if (!selectedParentNodes.some((node) => node?.id === event.currentTarget.id)) {
      let newNode = { id: event.currentTarget.id };
      let newSelectedNodes = [...selectedParentNodes];
      newSelectedNodes = Array.from({ length: parentNodesCount }, (_, i) => ({
        id: i < selectedParentNodes.length ? selectedParentNodes[i].id : ''
      }));
      newSelectedNodes[index] = { id: newNode.id };
      setSelectedParentNodes(newSelectedNodes);
    } else {
      setSelectedParentNodes((prevNodes) =>
        prevNodes.map((item, i) => ({
          id: i === index ? '' : item.id
        }))
      );
    }
    setIsExpand(!isExpand);
  };

  const handleChildClick = (rootName, nodeValue, isExpanded, isChildAvailable, childrens) => {
    if (!isExpanded) treeNodeHandler(rootName, nodeValue, isChildAvailable, childrens,treeIndex);
  };

  const handleCheckboxSelect = (event) => {
    const nodeId = event.target.id;
    const treeNode = selectedAllNodes;
    if (event.target.checked) {
      const selectedNode = treeNode.find((item) => item.id == nodeId);
      if(!selectedNode){
        const updatedTreeNodes = [...treeNode, { id: nodeId, name: event.target.value }];
        setSelectedAllNodes(updatedTreeNodes);
        setSelectedNodes(updatedTreeNodes);
      }
    } else {
      const updatedTreeNodes = treeNode.filter((item) => item.id !== nodeId);
      setSelectedAllNodes(updatedTreeNodes);
      setSelectedNodes(updatedTreeNodes);
    }
  };

  return (
    <>
      {nodes.map((item, index) => {
        return (
          <div
            key={index}
            className={`assignments-card col-4 cursor-pointer w-100 ${index % 3 === 0 ? 'clear-row' : ''}`}>
            <div className="select-questions p-1">
              <div
                id={item.name}
                className="d-flex align-items-center"
                onClick={(e) => handleParentClick(item.childrens, e, index)}>
                <div className="align-items-center d-flex icon-div justify-content-center m-2">
                  <FontAwesomeIcon
                    icon={
                      selectedParentNodes.find((node) => node.id === item.name) ? faMinus : faPlus
                    }
                    className="icon"
                  />
                </div>
                <div>{item.name}</div>
              </div>
              {selectedParentNodes.find((node) => node.id === item.name) && (
                <>
                  <TreeView
                    key={`tree${index}`}
                    data={item.childrens}
                    aria-label="Checkbox tree"
                    multiSelect
                    propagateSelect
                    propagateSelectUpwards
                    togglableSelect
                    nodeRenderer={({
                      element,
                      isBranch,
                      isExpanded,
                      getNodeProps,
                      handleExpand
                    }) => {
                      return (
                        <>
                          <div {...getNodeProps({ onClick: handleExpand })}>
                            {isBranch && (
                              <>
                                <div
                                  onClick={() =>
                                    handleChildClick(item.name, element.id, isExpanded, element.isChildAvailable, element.childrens)
                                  }>
                                  <div className="icon-div p-1 mb-2 margin-left-20">
                                    <FontAwesomeIcon
                                      icon={isExpanded ? faMinus : faPlus}
                                      className="icon"
                                      isOpen={isExpanded}                                       
                                    />
                                  </div>
                                  <span id={element.id} className="name">
                                    {element.name}
                                  </span>
                                </div>
                              </>
                            )}
                            {!isBranch && (
                              <div className="d-flex">
                                <Form.Check
                                  id={element.id}
                                  type="checkbox"
                                  className="checkbox-name margin-left-20"
                                  onChange={(e) => {
                                    handleCheckboxSelect(e);
                                    e.stopPropagation();
                                  }}
                                  value={element.name} 
                                  checked={(selectedAllNodes.filter((obj)=> obj.id == element.id)).length > 0}
                                />
                                <span
                                  id={element.id}
                                  className="linkto m-2 mb-1 mt-0">
                                  {element.name}
                                </span>
                              </div>
                            )}
                          </div>
                        </>
                      );
                    }}
                  />
                </>
              )}
            </div>
          </div>
        );
      })}
    </>
  );
};

Index.propTypes = {
  nodes: PropTypes.array,
  treeNodeHandler: PropTypes.func,
  parentNodesCount: PropTypes.number,
  selectedAllNodes: PropTypes.array,
  setSelectedAllNodes: PropTypes.func,
  setSelectedNodes: PropTypes.func,
  treeIndex: PropTypes.number
};

export default Index;
